module.exports = __webpack_public_path__ + "static/media/vlc.22c9593b.webp";